"use strict";

require("core-js/modules/es6.array.find");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.array.sort");

require("core-js/modules/es6.array.slice");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.array.find-index");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.object.keys");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

function _typeof(a) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (a) {
    return typeof a;
  } : function (a) {
    return a && "function" == typeof Symbol && a.constructor === Symbol && a !== Symbol.prototype ? "symbol" : typeof a;
  }, _typeof(a);
}

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _uuid = _interopRequireDefault(require("uuid")),
    _Form = _interopRequireDefault(require("../Form")),
    _Button = _interopRequireDefault(require("../Button")),
    S = _interopRequireWildcard(require("./styles"));

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    "default": a
  };
}

function _getRequireWildcardCache() {
  if ("function" != typeof WeakMap) return null;
  var a = new WeakMap();
  return _getRequireWildcardCache = function _getRequireWildcardCache() {
    return a;
  }, a;
}

function _interopRequireWildcard(a) {
  if (a && a.__esModule) return a;
  if (null === a || "object" !== _typeof(a) && "function" != typeof a) return {
    "default": a
  };

  var b = _getRequireWildcardCache();

  if (b && b.has(a)) return b.get(a);
  var c = {},
      d = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var e in a) {
    if (Object.prototype.hasOwnProperty.call(a, e)) {
      var f = d ? Object.getOwnPropertyDescriptor(a, e) : null;
      f && (f.get || f.set) ? Object.defineProperty(c, e, f) : c[e] = a[e];
    }
  }

  return c["default"] = a, b && b.set(a, c), c;
}

function ownKeys(a, b) {
  var c = Object.keys(a);

  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }

  return c;
}

function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) {
    b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
      _defineProperty(a, c, b[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
      Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
    });
  }

  return a;
}

function _defineProperty(a, b, c) {
  return b in a ? Object.defineProperty(a, b, {
    value: c,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[b] = c, a;
}

function _toConsumableArray(a) {
  return _arrayWithoutHoles(a) || _iterableToArray(a) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(a) {
  if (Symbol.iterator in Object(a) || "[object Arguments]" === Object.prototype.toString.call(a)) return Array.from(a);
}

function _arrayWithoutHoles(a) {
  if (Array.isArray(a)) {
    for (var b = 0, c = Array(a.length); b < a.length; b++) {
      c[b] = a[b];
    }

    return c;
  }
}

function _slicedToArray(a, b) {
  return _arrayWithHoles(a) || _iterableToArrayLimit(a, b) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(a, b) {
  if (Symbol.iterator in Object(a) || "[object Arguments]" === Object.prototype.toString.call(a)) {
    var c = [],
        d = !0,
        e = !1,
        f = void 0;

    try {
      for (var g, h = a[Symbol.iterator](); !(d = (g = h.next()).done) && (c.push(g.value), !(b && c.length === b)); d = !0) {
        ;
      }
    } catch (a) {
      e = !0, f = a;
    } finally {
      try {
        d || null == h["return"] || h["return"]();
      } finally {
        if (e) throw f;
      }
    }

    return c;
  }
}

function _arrayWithHoles(a) {
  if (Array.isArray(a)) return a;
}

var _default = function _default(a) {
  function b(a) {
    var b = t.findIndex(function (b) {
      return b.name === a;
    }),
        c = [].concat(_toConsumableArray(t.slice(0, b)), _toConsumableArray(t.slice(b + 1)));
    u(c);
  }

  var c = a.label,
      d = a.onSubmit,
      e = a.initialValue,
      f = void 0 === e ? [] : e,
      g = a.inputs,
      h = a.defaultValue,
      i = a.validationSchema,
      j = a.generatedInputsMapper,
      k = a.showAddField,
      l = a.inlineSortWrapperStyle,
      m = a.hideDeleteItem,
      n = a.hideInputSort,
      o = a.previewFormLayout,
      p = a.modalFormLayout,
      q = a.disabled,
      r = (0, _react.useState)(f),
      s = _slicedToArray(r, 2),
      t = s[0],
      u = s[1],
      v = (0, _react.useState)(!1),
      w = _slicedToArray(v, 2),
      x = w[0],
      y = w[1],
      z = (0, _react.useState)(j(t)),
      A = _slicedToArray(z, 2),
      B = A[0],
      C = A[1],
      D = (0, _react.useState)(!1),
      E = _slicedToArray(D, 2),
      F = E[0],
      G = E[1],
      H = (0, _react.useState)(!1),
      I = _slicedToArray(H, 2),
      J = I[0],
      K = I[1];

  return (0, _react.useEffect)(function () {
    var a = j(t);
    C(a), t !== f && (y(!0), d(t));
  }, [t]), (0, _react.useEffect)(function () {
    x && y(!1);
  }, [x]), g ? _react["default"].createElement(S.FormInputsGenerator, {
    overlay: J || F
  }, _react["default"].createElement(S.FormInputsGeneratorInner, null, _react["default"].createElement(S.FormInputsGeneratorHeader, null, F && _react["default"].createElement(S.FormInputsGeneratorTitle, null, "edit: ".concat(F)), J && c && "string" == typeof c && _react["default"].createElement(S.FormInputsGeneratorTitle, null, "Adding", c, " ", "item"), !F && !J && (!t || 0 === t.length) && c && "string" == typeof c && _react["default"].createElement(S.FormInputsGeneratorTitle, null, c), (F || J) && _react["default"].createElement(_Button["default"], {
    type: null,
    onClick: function onClick() {
      G(null), K(null);
    },
    size: "small",
    icon: "close"
  })), !F && !J && t && 0 < t.length && !x && _react["default"].createElement(S.FormPreview, null, _react["default"].createElement(_Form["default"], {
    showSubmit: null,
    layout: o,
    inputs: B,
    onInputSort: n ? null : function (a) {
      var b = t.map(function (b, c) {
        return _objectSpread({}, b, {
          order: a.findIndex(function (a) {
            return a === c;
          })
        });
      }).sort(function (c, a) {
        return c.order > a.order ? 1 : -1;
      });
      u(b);
    },
    inlineSortWrapperStyle: n ? null : l,
    InputWrapper: function InputWrapper(a) {
      var c = a.children,
          d = a.name;
      return _react["default"].createElement(S.InputWrapper, null, _react["default"].createElement(S.InputInner, {
        className: "inputInner"
      }, _react["default"].createElement(_Button["default"], {
        type: null,
        icon: "edit",
        onClick: function onClick() {
          return G(d);
        }
      }), !m && _react["default"].createElement(_Button["default"], {
        type: "danger",
        icon: "delete",
        onClick: function onClick() {
          return b(d);
        }
      })), c);
    }
  })), J && _react["default"].createElement(_Form["default"], {
    inputs: g,
    layout: p,
    submitLabel: "Save",
    submitIcon: "save",
    onSubmit: function onSubmit(a, b) {
      var c = b.setSubmitting;
      u([].concat(_toConsumableArray(t), [_objectSpread({}, a, {
        name: a.name || (0, _uuid["default"])()
      })])), K(!1), c(!1);
    },
    initialValues: h,
    validationSchema: i
  }), F && _react["default"].createElement(S.EditModeWrapper, null, _react["default"].createElement(_Form["default"], {
    inputs: g,
    layout: p,
    submitLabel: "edit",
    onSubmit: function onSubmit(a, b) {
      var c = b.setSubmitting,
          d = t.findIndex(function (a) {
        return a.name === F;
      });
      u([].concat(_toConsumableArray(t.slice(0, d)), [a], _toConsumableArray(t.slice(d + 1)))), G(!1), c(!1);
    },
    initialValues: t.find(function (a) {
      return a.name === F;
    }),
    validationSchema: i
  }), q && _react["default"].createElement(S.DisablingMask, null)), !J && !F && k && _react["default"].createElement(S.Center, null, _react["default"].createElement(_Button["default"], {
    type: "dashed",
    icon: "plus",
    onClick: function onClick() {
      return K(!0);
    }
  }, "Add")))) : null;
};

exports["default"] = _default;